import * as Haptics from 'expo-haptics';
import { useTranslation } from 'react-i18next';
import { Platform, StyleSheet } from 'react-native';
import { Button } from 'react-native-paper';
import { Colors } from '.././../../themes';

interface FormState {
  isDirty?: boolean;
  isValid?: boolean;
}

export type CommonSubmitButtonProps = {
  onPress: () => void;
  formState: FormState;
  buttonText?: string;
  isPending?: boolean;
  isFromDraft?: boolean;
};

export const CommonSubmitButton = (props: CommonSubmitButtonProps) => {
  const { t } = useTranslation();
  const { isDirty, isValid } = props.formState;
  const buttonText = props.buttonText?.toLocaleLowerCase() || 'update';

  // If form is from draft, don't require isDirty check (drafts should be submittable)
  const isDisabled =
    isValid === false || (!props.isFromDraft && isDirty === false) || props.isPending === true;

  return (
    <Button
      mode="contained"
      style={[
        styles.submitButton,
        {
          backgroundColor: isDisabled ? Colors.grayFill : Colors.primary,
        },
      ]}
      labelStyle={styles.buttonLabel}
      onPress={() => {
        if (Platform.OS === 'ios') {
          Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Medium);
        }
        props.onPress();
      }}
      disabled={isDisabled}
    >
      {t(`routines.${buttonText}`)}
    </Button>
  );
};

const styles = StyleSheet.create({
  submitButton: {
    flex: 1,
    height: 52,
    borderRadius: 12,
    justifyContent: 'center',
  },
  buttonLabel: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '600',
    color: Colors.white,
  },
});
